import { ProcessMenu } from './menu-processing'
const menu = [
  [
    {
      title: 'Playwatch',
      id: 'Playwatch-6',
      type: 'group',
      children: [
        {
          title: 'Creator',
          id: 'Creator-10',
          type: 'collapse',
          claim: 'ContentCreator',
          children: [
            {
              title: 'Content House',
              id: 'Content House-7',
              paths: ['/'],
              hidden: false,
              targetView: 'Houses',
              type: 'item',
            },
            {
              title: 'House',
              id: 'House-8',
              paths: ['/:id'],
              hidden: true,
              targetView: 'ContentHouses',
              type: 'item',
            },
            {
              title: 'New Content House',
              id: 'New Content House-9',
              paths: ['/:id', '/', '/:id/:creator'],
              hidden: true,
              targetView: 'ContentCreators',
              type: 'item',
            },
          ],
          script:
            '(function checkAuthorization(): any {\n    if (isLoggedIn && claims && !claims?.contentCreator) {\n        navigate(`/${(Views.Home)}`, { replace: true });\n    }\n})();',
        },
      ],
    },
  ],
]
export default ProcessMenu(menu)
